import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App.js'
import { replayQueue, startQueueWatcher } from './api/client.js'
import './styles/index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // One retry covers the few seconds kamal-proxy spends swapping containers
      // during a deploy.
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: true,
    },
  },
})

// Draining the queue invalidates everything, so the UI reflects what the server
// actually accepted rather than the optimistic guess.
startQueueWatcher(() => {
  void queryClient.invalidateQueries()
})

// Returning to the tab is a good moment to retry anything still queued.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    void replayQueue().then((r) => {
      if (r.sent > 0) void queryClient.invalidateQueries()
    })
  }
})

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
